/**
 * 辅助table，简化操作
 */
export default {
  name: 'TableMixin',
  data() {
    return {
      // loading状态
      loading: false,
      // 分页配置
      pageIndex: 1,
      pageSize: 20,
      total: 200
    }
  },

  computed: {
    currentPage: {
      get() {
        return this.pageIndex
      },
      set(n) {
        this.pageIndex = n
      }
    }
  },

  methods: {
    /**
     * 切换每页最大数
     */
    pageSizeChange(param) {
      this.pageSize = param
      this.pageIndex = 1
      this.getTableList()
    },
    /**
     * 切换页
     */
    pageChange(e) {
      this.pageIndex = e
      this.getTableList()
    },
    /**
     * 使用该mixin的组件需要实现该方法做table的基础查询
     */
    getTableList() {}
  }
}
